/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-07T09:38:28.035
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getCCBSyncLogEditInit,
	getCCBSyncLogView
} from '@api/house/CCBSyncLog';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},

	actions: {
		getCCBSyncLogEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBSyncLogEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getCCBSyncLogView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBSyncLogView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
